import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {User, UserPublic} from '../models/user';
import {catchError, retry} from 'rxjs/operators';
import {HttpAbstract} from '../../../../shared/abstract/http.abstract';

@Injectable({
  providedIn: 'root'
})
export class UserService extends HttpAbstract {

  private url = environment.url.api.administrator.user;

  constructor(private httpClient: HttpClient) {
    super();
  }

  getAll(): Observable<UserPublic[]> {
    return this.httpClient
      .get<UserPublic[]>(`${this.url}`)
      .pipe(
        retry(1),
        catchError(this.handleError));
  }

  getById(id: string): Observable<UserPublic> {
    return this.httpClient
      .get<UserPublic>(`${this.url}${id}`)
      .pipe(
        retry(1),
        catchError(this.handleError));
  }

  post(data: User): Observable<User> {
    return this.httpClient
      .post<User>(this.url, data)
      .pipe(
        catchError(this.handleError));
  }

  put(data: User): Observable<User> {
    return this.httpClient
      .put<User>(this.url, data)
      .pipe(
        catchError(this.handleError));
  }

  putEnable(data: any): Observable<User> {
    return this.httpClient
      .put<User>(`${this.url}enable`, data)
      .pipe(
        catchError(this.handleError));
  }

  delete(id: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      body: {id}
    }
    return this.httpClient
      .delete(this.url, options)
      .pipe(
        catchError(this.handleError));
  }

}
